export const version = "ethers/5.6.2";
//# sourceMappingURL=_version.js.map